import { RenderWhenPriceEnabled } from '../../context/PriceContext';
import { MoneyData } from '../../data/model';
import { PriceDifferenceTranslation } from '../../localization/SiteTranslation';
import Price from './Price';
import css from './PriceDifference.css';

interface PriceProps {
  price: MoneyData;
  className?: string;
  displayAsFromPrice?: boolean;
  translation?: PriceDifferenceTranslation;
}

const PriceDifference = ({ price, className, displayAsFromPrice, translation }: PriceProps) => {
  const sign = price.amount > 0 ? '+' : '-';
  const displayFromPrice = translation && price.amount > 0 && displayAsFromPrice;

  return (
    <RenderWhenPriceEnabled>
      {price.amount !== 0 && (
        <span className={css.PriceDifference}>
          {displayFromPrice ? (
            <span>{translation.startsFromPriceText} </span>
          ) : (
            <span className={css.differenceSign}>{sign}</span>
          )}
          <Price price={price} className={className} />
        </span>
      )}
    </RenderWhenPriceEnabled>
  );
};

export default PriceDifference;
